import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { titanApi } from "../../../../services/API/titanApi";
import {
  selectTotalDesignLoad,
  selectedCarryingElement,
  setCarryingElementName,
} from "../../../../store/slices/aashtoSlice";
import { BemessungenMikropfaehle } from "../../../../store/slices/bemessungenMikropfaehleSlice";

function DesignLoadSelection() {
  const dispatch = useDispatch();

  const designLoad = useSelector(selectTotalDesignLoad);
  const selectedElement = useSelector(selectedCarryingElement);
  const [allElements, setAllElements] = useState([]);

  // TODO: Add to slice
  const [trigger, { isLoading, isError }] =
    titanApi.endpoints.getCarryElements.useLazyQuerySubscription();

  useEffect(() => {
    trigger({ fd: 0, type: BemessungenMikropfaehle.AASHTO })
      .catch((e) => console.error(e))
      .then((result) => {
        setAllElements(result.data);
        let el = result.data.find((e) => e?.name === selectedElement.name);
        if (!result.data.some((e) => e?.name === selectedElement.name)) {
          dispatch(setCarryingElementName(result.data[0]?.name));
        }
        if (el?.RkmaxNumber < designLoad.metric) {
          let index = result.data.findIndex((e) => e?.RkmaxNumber >= designLoad.metric);
          if (index >= 0) {
            dispatch(setCarryingElementName(result.data[index]?.name));
          }
        }
      });
  }, [designLoad.metric]);

  return (
    <div>
      {isError && <h1 className="red">Error</h1>}
      <select
        value={selectedElement?.name}
        className="change-input"
        name="carryingElement-value"
        id="carryingElement"
        onChange={(e) => {
          dispatch(setCarryingElementName(e.target.value));
        }}
      >
        {allElements?.map((el, index) => {
          return (
            <option key={index} value={el?.name}>
              {el?.name}
            </option>
          );
        })}
      </select>
    </div>
  );
}

export default DesignLoadSelection;
